import { render, staticRenderFns } from "./switcher.vue?vue&type=template&id=54b7bb0c&scoped=true&"
import script from "./switcher.vue?vue&type=script&lang=js&"
export * from "./switcher.vue?vue&type=script&lang=js&"
import style0 from "./switcher.vue?vue&type=style&index=0&id=54b7bb0c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b7bb0c",
  null
  
)

export default component.exports